import { fg_busy } from "@clockwise/design-system/tokens";
import { OpenInNew } from "@clockwise/icons";
import { Update } from "@clockwise/web-commons/src/components/popper/Update";
import classNames from "classnames";
import React from "react";

type Props = {
  canProposeNewTime?: boolean;
  disabled?: boolean;
  emphasis?: boolean;
  onClick: () => void;
};

export const FindMoreTimesButton = ({
  canProposeNewTime = false,
  disabled = false,
  emphasis = false,
  onClick,
}: Props) => {
  return (
    <div
      className={classNames(
        "cw-border cw-border-solid cw-rounded",
        "cw-px-2 cw-py-1.5",
        "cw-body-base",
        "cw-text-busy",
        "cw-border-subtle",
        disabled ? "" : "hover:cw-border-subtle-hover",
        "cw-bg-default",
        disabled ? "" : "hover:cw-bg-default-hover",
        disabled ? "cw-cursor-default" : "cw-cursor-pointer",
        { "cw-animate-dropShadow-out": emphasis },
      )}
      onClick={onClick}
      role={"button"}
      tabIndex={0}
    >
      <div className="cw-w-full cw-flex cw-flex-row cw-items-center cw-justify-between cw-font-normal cw-text-13 cw-leading-6">
        <>
          <div className="cw-grow cw-text-left cw-font-medium">
            <div className="cw-flex cw-flex-row cw-space-x-1 cw-items-center">
              <Update fill={fg_busy} className="cw-font-[16px]" />
              <div>{canProposeNewTime ? "Propose new time" : "Find more times"}</div>
            </div>
          </div>
          <div className="cw-flex cw-flex-row cw-space-x-1 cw-items-center">
            <OpenInNew fill={fg_busy} style={{ fontSize: 15 }} />
          </div>
        </>
      </div>
    </div>
  );
};
